import _ from 'lodash';
import gameConstants from './gameConstants';

export function createGame(game) {
    return {
        ...game,
        started: true,
        startedOnce: true,
        round: gameConstants.startRound,
        scores: [gameConstants.startScore1, gameConstants.startScore2],
        try: gameConstants.startTry,
        stage: 'initial',
        playingAudio: false,
        discussionStep: -1,
    };
}

export function getCurrentTeamIndex(game) {
    return (game.round + game.try) % 2;
}

export function isLastRound(game) {
    return getStableRound(game) === gameConstants.endRound;
}

export function getStableRound(game) {
    return game.roundChanging ? game.round - 1 : game.round;
}

export function isTeamWin(game, teamIndex) {
    return game.scores[teamIndex] > game.scores[1 - teamIndex];
}

export function isDraw(game) {
    return game.scores[0] === game.scores[1];
}

export const allPoses = [
    'void',
    'listen',
    'initial',
    'wait-try',
    'prompt',
    'wrong-answer',
    'wrong-answer-multiple-pre',
    'wrong-answer-multiple',
    'wrong-answer-multiple-timeout',
    'prompt-multiple',
    'right-answer',
    'right-answer-multiple',
    'discussion-wait',
    'discussion-listen',
    'discussion-analyze',
];

export const waitPoses = ['wait-try', 'discussion-wait'];
export const listenPoses = ['listen', 'discussion-listen'];
export const promptStages = ['prompt', 'prompt-multiple'];
export const promptPoses = promptStages;
export const wrongAnswerTimeoutPoses = ['wrong-answer', 'wrong-answer-multiple-timeout'];
export const wrongPoses = [
    'wrong-answer',
    'wrong-answer-multiple-pre',
    'wrong-answer-multiple',
    'wrong-answer-multiple-timeout',
];
export const rightPoses = ['right-answer', 'right-answer-multiple'];
export const twoPanePoses = [
    'prompt-multiple',
    'wrong-answer-multiple-pre',
    'wrong-answer-multiple',
    'wrong-answer-multiple-timeout',
    'right-answer-multiple',
    'discussion-listen',
    'discussion-analyze',
];
export const lyricsPoses = ['discussion-listen', 'discussion-analyze'];
export const questionPoses = [...promptPoses, 'discussion-analyze'];
export const teamScorePoses = [
    'wait-try',
    'listen',
    'prompt',
    'prompt-multiple',
    'wrong-answer-multiple-pre',
    'right-answer-multiple',
];
